import { useMutation } from 'react-query';
import { MutationConfig, queryClient } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const editAtmServiceProvider = ( {data, atmServiceProviderId} : {data: IPostEditAtmServiceProvider | {}, atmServiceProviderId: number}): Promise<string> => {
  return axiosDefaultApi.put(`/api/AtmServiceProviders/UpdateAtmServiceProvider/${atmServiceProviderId}`, data);
};

type QueryFnType = typeof editAtmServiceProvider;

type UseEditAtmServiceProviderOptions = {
  data: IPostEditAtmServiceProvider | {};
  atmServiceProviderId: number;
  config?: MutationConfig<QueryFnType>;
};

export const useEditAtmServiceProvider = ({ config }: UseEditAtmServiceProviderOptions) => { 
    const {addNotification, setIsNotificationVisible} = useNotification();
    return useMutation({
        onError: (error: any) => {
            addNotification(`Υπήρξε κάποιο πρόβλημα στην επεξεργασία του ATM Service Provider.`, 500);
            console.error('Couldnt edit AtmServiceProvider', error);
            setIsNotificationVisible(true)
          },
          onSuccess: () => {
            queryClient.invalidateQueries(["getAllAtmServiceProviders"])
            addNotification('Το ATM Service Provider Ενημερώθηκε.', 200);
            setIsNotificationVisible(true)
          },
        ...config,
        mutationFn: editAtmServiceProvider,
    })
}